"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateStringNumber = void 0;
function validateStringNumber(val) {
    if (typeof val !== 'string')
        return false;
    // Tests if a string is a valid integer, leading zero is not allowed i.e. 01
    return /(^0$|^[1-9]\d*$)/.test(val);
}
exports.validateStringNumber = validateStringNumber;
//# sourceMappingURL=validateStringNumber.js.map